import {
	Combobox,
	type ComboboxProps,
	SelectPopover,
	type SelectPopoverProps
} from '@ariakit/react'
import { forwardRef, type HTMLAttributes } from 'react'
import { SearchLgIcon } from '@/components/ui/icons'

export const OpsVettingFlagsSelectSearchInput = forwardRef<
	HTMLInputElement,
	ComboboxProps
>((props, ref) => (
	<div className='flex items-center gap-2 px-3.5 py-3 [&_svg]:text-neutral-500'>
		<SearchLgIcon size={20} />
		<Combobox
			autoSelect
			render={
				<input className='w-full text-base' ref={ref} type='text' />
			}
			{...props}
		/>
	</div>
))

export const OpsVettingFlagsSelectStyledPopover = (
	props: SelectPopoverProps
) => (
	<SelectPopover
		className='grid w-80 grid-rows-[auto_auto_minmax(0,1fr)] rounded-xl border border-neutral-200 bg-neutral-white p-0 shadow-lg'
		gutter={12}
		{...props}
	/>
)

export const OpsVettingFlagsSelectItem = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={`flex w-full gap-2 break-words px-3 py-2 font-medium text-neutral-700 text-sm transition-all duration-150 ${className ?? ''}`}
		{...props}
	/>
)
